import { EColors2, EFonts } from 'libs/styles/styling';
import { useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components/macro';

interface Props {
    label?: string;
    value: string;
    multiple?: boolean;

    placeholder?: string;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    className?: string;
    minRows?: number;
    maxRows?: number;
    color?: string;
    autoFocus?: boolean;
}

export const GuideInputText = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);

    useEffect(() => {
        if (value !== props.value) {
            props.onChange?.(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <S_GuideInputText className={props.className}>
            <S_Label>
                {props.label && <S_LabelText $color={props.color}>{props.label}</S_LabelText>}
                {props.multiple ? (
                    <TextareaAutosize
                        value={value ?? ''}
                        onChange={(e) => {
                            setValue(e.target['value']);
                        }}
                        maxRows={props.maxRows ?? 5}
                        minRows={props.minRows ?? 1}
                        onBlur={props.onBlur}
                        autoFocus={props.autoFocus}
                    />
                ) : (
                    <input
                        value={value ?? ''}
                        placeholder={props.placeholder}
                        onChange={(e) => {
                            setValue(e.target['value']);
                        }}
                        onBlur={props.onBlur}
                        autoFocus={props.autoFocus}
                    />
                )}
            </S_Label>
        </S_GuideInputText>
    );
};

const S_GuideInputText = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    textarea,
    input {
        width: 100%;
        background-color: #fafcfe;
        border: 1px solid #e3e3e3;
        border-radius: 15px;
        font-family: ${EFonts.Regular};
        padding: 15px 20px;
        font-size: 15px;
        color: ${EColors2.DARK};
        min-width: 45px;
        resize: none;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        box-sizing: border-box;
    }
    input {
        height: 44px;
        line-height: 35px;
    }
`;

const S_Label = styled.label`
    display: block;
`;

const S_LabelText = styled.div<{ $color: string }>`
    color: ${(props) => props.$color ?? EColors2.DARK};
    font-size: 16px;
    margin: 0 0 12px 0;
    font-family: ${EFonts.Medium};
`;
